import type { ReactNode } from 'react';
import NextLink from 'next/link';
import { LinkContextProvider } from '../link-context-provider';
import { isExternalUrl } from '../is-external-url';
import { urlObjectToString } from '../url-object-to-string';
import type { UniversalLinkProps } from '../types';

function NextLinkAdapter({
  href,
  replace,
  prefetch,
  scroll,
  legacyBehavior,
  ref,
  ...rest
}: UniversalLinkProps) {
  const hrefStr = urlObjectToString(href);
  if (isExternalUrl(hrefStr)) {
    return <a ref={ref} href={hrefStr} {...rest} />;
  }

  return (
    <NextLink
      ref={ref}
      href={href}
      replace={replace}
      prefetch={prefetch}
      scroll={scroll}
      {...(legacyBehavior !== undefined && { legacyBehavior })}
      {...rest}
    />
  );
}

type NextLinkProviderProps = {
  children: ReactNode;
};

export function NextLinkProvider({ children }: NextLinkProviderProps) {
  return <LinkContextProvider Link={NextLinkAdapter}>{children}</LinkContextProvider>;
}
